var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBxDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 13.3333L13.3337 9.16658H10.8337V3.33325H9.16699V9.16658H6.66699L10.0003 13.3333Z",
    fill: "#FC1999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 15.0001H3.33366V9.16675H1.66699V15.0001C1.66699 15.9192 2.41449 16.6667 3.33366 16.6667H16.667C17.5862 16.6667 18.3337 15.9192 18.3337 15.0001V9.16675H16.667V15.0001Z",
    fill: "#FC1999"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxDownload);
export default __webpack_public_path__ + "static/media/bx_download.b8fc74f2b610142c155b40c1a3869bb1.svg";
export { ForwardRef as ReactComponent };